<section id="contact" class="section bg-light">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 mx-auto text-center mb-5">
        <h2 class="display-5 fw-bold mb-4">{{ getTranslation('contact.title') }}</h2>
        <p class="lead text-muted">{{ getTranslation('contact.subtitle') }}</p>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-8 mx-auto">
        <div class="card card-custom shadow-lg">
          <div class="card-body p-5">

            <!-- Success/Error Messages -->
            <div *ngIf="submitStatus === 'success'" class="alert alert-success mb-4" role="alert">
              <i class="fas fa-check-circle me-2"></i>
              {{ submitMessage }}
            </div>

            <div *ngIf="submitStatus === 'error'" class="alert alert-danger mb-4" role="alert">
              <i class="fas fa-exclamation-circle me-2"></i>
              {{ submitMessage }}
            </div>

            <!-- Contact Form -->
            <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" novalidate>

              <!-- Name Field -->
              <div class="form-floating-custom mb-4">
                <div class="form-floating">
                  <input
                    type="text"
                    class="form-control"
                    [class.is-invalid]="isFieldInvalid('name')"
                    id="name"
                    formControlName="name"
                    [placeholder]="getTranslation('contact.form.name')">
                  <label for="name">{{ getTranslation('contact.form.name') }}</label>
                </div>
                <div *ngIf="isFieldInvalid('name')" class="invalid-feedback d-block">
                  {{ getFieldError('name') }}
                </div>
              </div>

              <!-- Email Field -->
              <div class="form-floating-custom mb-4">
                <div class="form-floating">
                  <input
                    type="email"
                    class="form-control"
                    [class.is-invalid]="isFieldInvalid('email')"
                    id="email"
                    formControlName="email"
                    [placeholder]="getTranslation('contact.form.email')">
                  <label for="email">{{ getTranslation('contact.form.email') }}</label>
                </div>
                <div *ngIf="isFieldInvalid('email')" class="invalid-feedback d-block">
                  {{ getFieldError('email') }}
                </div>
              </div>

              <!-- Message Field -->
              <div class="form-floating-custom mb-4">
                <div class="form-floating">
                  <textarea
                    class="form-control"
                    [class.is-invalid]="isFieldInvalid('message')"
                    id="message"
                    formControlName="message"
                    style="height: 120px"
                    [placeholder]="getTranslation('contact.form.message')"></textarea>
                  <label for="message">{{ getTranslation('contact.form.message') }}</label>
                </div>
                <div *ngIf="isFieldInvalid('message')" class="invalid-feedback d-block">
                  {{ getFieldError('message') }}
                </div>
              </div>

              <!-- Submit Button -->
              <div class="text-center">
                <button
                  type="submit"
                  class="btn btn-gradient btn-lg px-5"
                  [disabled]="isSubmitting">

                  <div *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>

                  <i *ngIf="!isSubmitting" class="fas fa-paper-plane me-2"></i>

                  {{ isSubmitting ? getTranslation('contact.form.sending') : getTranslation('contact.form.submit') }}
                </button>
              </div>
            </form>
          </div>
        </div>

        <!-- Contact Info -->
        <div class="row mt-5">
          <div class="col-md-3 text-center mb-4">
            <div class="contact-info-item">
              <div class="contact-icon mb-3">
                <i class="fas fa-envelope fa-2x text-primary"></i>
              </div>
              <h5>Email</h5>
              <p class="text-muted">stradetskyi&#64;gmail.com</p>
            </div>
          </div>

          <div class="col-md-3 text-center mb-4">
            <div class="contact-info-item">
              <div class="contact-icon mb-3">
                <i class="fas fa-phone fa-2x text-primary"></i>
              </div>
              <h5>Phone</h5>
              <p class="text-muted">+380 96 806 5282</p>
            </div>
          </div>

          <div class="col-md-3 text-center mb-4">
            <div class="contact-info-item">
              <div class="contact-icon mb-3">
                <i class="fab fa-linkedin fa-2x text-primary"></i>
              </div>
              <h5>LinkedIn</h5>
              <p class="text-muted">
                <a href="https://www.linkedin.com/in/oleksandr-stradetskyi/"
                   target="_blank"
                   rel="noopener noreferrer"
                   class="text-decoration-none text-muted">
                  {{ getTranslation('contact.linkedin') }}
                </a>
              </p>
            </div>
          </div>

          <div class="col-md-3 text-center mb-4">
            <div class="contact-info-item">
              <div class="contact-icon mb-3">
                <i class="fab fa-telegram fa-2x text-primary"></i>
              </div>
              <h5>Telegram</h5>
              <p class="text-muted">
                <a href="https://t.me/stradetskyi"
                   target="_blank"
                   rel="noopener noreferrer"
                   class="text-decoration-none text-muted">
                  {{ getTranslation('contact.telegram') }}
                </a>
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>
